import React from "react";
import BottomNavigation, {
  BottomNavigationAction
} from "material-ui/BottomNavigation";
import classnames from "classnames";
import {Paper, Grid, Button} from "material-ui";
import { withStyles } from "material-ui/styles";
import { LinearProgress } from "material-ui/Progress";
import CountUp from "react-countup";

import CTable, {
  CTableHead,
  CTableBody,
  CTableRow,
  CHeadCell,
  CBodyCell
} from "uis/CTable";
import BackButton from "components/BackButton";
import axios from "axios";
import storage from "../utils/storage";
import {baseApiUrl} from "../api";
import {isAdmin, pathRole} from "../utils/formatter";
import Dialog, {DialogActions} from "material-ui/Dialog/index";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0
  },
  main: {
    padding: 20
  },
  customerName: {
    marginLeft: "1rem",
    color: "#575962"
  },
  btnNavActionRoot: {
    maxWidth: "none"
  },
  soloLocale: {
    pointerEvents: "none"
  },
  selectedNavItem: {
    color: "#fff",
    backgroundColor: "#26a69a"
  },
  statusLabel: {
    borderRadius: 15,
    color: "white",
    padding: "2px 15px",
    fontWeight: "normal"
  },
  paperDiv: {
    padding: "2rem 1.8rem 3rem",
    marginBottom: "2rem",
    position: "relative"
  },
  paperTitle: {
    color: "#575962",
    marginBottom: "1rem",
    display: "inline-block",
    fontSize: "1.1rem",
    fontWeight: 600
  },
  paperRow: {
    marginBottom: 15
  },
  paperDesc: {
    color: "#9699a2",
    fontSize: "1rem",
    fontWeight: 300
  },
  paperValue: {
    color: "#575962",
    marginTop: "0.1rem",
    marginLeft: "2rem",
    display: "inline-block",
    fontSize: "1.1rem",
    fontWeight: 600
  },
  paperPeriod: {
    color: "#575962",
    marginTop: "0.1rem",
    marginLeft: "2rem",
    display: "inline-block",
    fontSize: "0.9rem",
    fontWeight: 600
  },
  paperStats: {
    float: "right",
    marginTop: "-1rem",
    fontSize: "1.75rem",
    fontWeight: 600,
    color: "#26a69a"
  },
  progressDiv: {
    borderRadius: 8,
    margin: "0.5rem 0",
    marginTop: 30
  },
  progress: {
    height: 20,
    borderRadius: 15
  },
  progressDesc: {
    color: "#9699a2",
    display: "inline-block",
    fontSize: "1rem",
    fontWeight: 300
  },
  progressStats: {
    float: "right",
    color: "#9699a2",
    display: "inline-block",
    fontSize: "1rem",
    fontWeight: 300
  },
  paperHeader: {
    padding: "1rem 1.8rem",
    borderBottom: "1px solid #ebedf2",
    color: "#575962",
    fontSize: "1.1rem",
    fontWeight: 600
  },
  paperContent: {
    padding: 20
  },
  publish: {
    color: "#26a69a"
  },
  outputButton: {
    backgroundColor: "#678ecc",
    color: "white",
    border: "none",
    borderRadius: 5,
    padding: "10px 15px",
    fontSize: "1rem",
    fontWeight: 600,
    cursor: "pointer",
    display: 'block',
    marginLeft: '135px'
  },
});
let timer = 0;
class SurveyProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      completed: 0,
      isMessageShowBeforeDownload: false
    };
  }
  componentWillMount() {
    this.props.fetchSurveyProgress();
    window.scroll(0, 0);
  }

  componentDidMount() {
    timer = setInterval(() => this.progress(), 200);
  }

  componentWillUnmount() {
    clearInterval(timer);
    this.props.initSurveyProgress();
  }

  progress() {
    const { survey } = this.props.surveyProgress;
    if (survey.id === null) {
      return;
    }
    const { completed } = this.state;
    const progressRatio = survey.progressRatio();

    if (completed < progressRatio) {
      this.setState({ completed: completed + survey.tickProgress() });
    } else {
      this.setState({ completed: progressRatio });
      clearInterval(timer);
    }
  }
  render() {
    const { classes, surveyProgress, employeeCount } = this.props;
    const {
      survey,
      customer,
      surveyLocales,
      selectedSurveyLocale,
      deptResults
    } = surveyProgress;

    const {
      urlNullCount
    } = employeeCount;

    const {
      isMessageShowBeforeDownload
    } = this.state;

    const downloadSurveyAnswers = () => {
      if (urlNullCount > 0) {
        this.setState({
          isMessageShowBeforeDownload: true
        });
      } else {
        const endpoint = isAdmin()
          ? '/admin/download_answer_result'
          : '/customer_admin/download_answer_result';

        axios.get(
          `${baseApiUrl()}${endpoint}`,
          {
            params: {
              token: storage.getToken(),
              survey_id: survey.id,
            },
            responseType: 'blob',
          }).then((response) => {
          const fileType = "text/csv;charset=utf-8;";
          const blob = new Blob([response.data], {type: fileType});
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;

          const now = new Date();
          const dateString = [
            now.getFullYear(),
            String(now.getMonth() + 1).padStart(2, '0'),
            String(now.getDate()).padStart(2, '0')
          ].join('');

          link.setAttribute("download", `niser-es_${customer.customerKey}_resStatus_${dateString}.csv`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }).catch((error) => {
          this.setState({
            isLoading: false,
          });

          let status = {
            isSuccess: false,
            messages: "CSVエクスポート中に予期せぬエラーが発生しました。",
          };

          if (error.response) {
            if (error.response.status === 404) {
              const backendMessage = error.response.data && error.response.data.error_message;
              status.messages = backendMessage || "登録されている回答者情報がありません。";

            } else if (error.response.data && error.response.data.errors) {
              status.messages = error.response.data.errors;

            } else {
              status.messages = `エラーが発生しました (${error.response.status}).`;
            }
          }
          this.setState({
            uploadStatus: status,
          });
        });
      }
    };

    const closeIsMessageShowBeforeDownload = () => {
      this.setState({
        isMessageShowBeforeDownload: false,
      });
    };

    return (
      <Paper className={classes.container}>
        {this.props.linerProgress.show && <LinearProgress color="accent" />}

        <div className={classes.header}>
          <h2 className={classes.title}>アンケート回答状況モニタリング</h2>
          <BackButton />
        </div>

        <Dialog
          fullWidth
          maxWidth="md"
          open={isMessageShowBeforeDownload}
          onClose={closeIsMessageShowBeforeDownload}
        >
          <div style={{
            marginTop: "40px",
            marginLeft: "275px",
            fontSize: "1.25rem"
          }}
          >
            <span>
              アンケート実施URLの発行をしてください。
            </span>
          </div>
          <DialogActions>
            <Button
              raised
              onClick={closeIsMessageShowBeforeDownload}
              style={{
                backgroundColor: "#4A3E92",
                marginTop: "30px",
                marginBottom: "10px",
                fontSize: "1.25rem"
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <div className={classes.main}>
          <h3 className={classes.customerName}>
            {customer.customerName}（ID:{customer.customerKey}）
          </h3>
          <Grid container spacing={24}>
            <Grid item xs={12} md={6}>
              <Paper
                className={classes.paperDiv}
                style={{ height: 260, boxSizing: "inherit" }}
              >
                <h4 className={classes.paperTitle}>
                  {selectedSurveyLocale.surveyName}
                </h4>
                <div className={classes.paperRow}>
                  <div>
                    <span className={classes.paperDesc}>公開期間</span>
                  </div>
                  <div className={classes.paperPeriod}>
                    <span>{survey.termFmt()}</span>
                  </div>
                </div>
                <div className={classes.paperRow}>
                  <div>
                    <span className={classes.paperDesc}>状態</span>
                  </div>
                  <div className={classes.paperValue}>
                    <div
                      className={classes.statusLabel}
                      style={survey.backgroundColor()}
                    >
                      {survey.statusFmt()}
                    </div>
                  </div>
                </div>
                <BottomNavigation
                  value={selectedSurveyLocale.localeId}
                  onChange={this.props.changeLocale}
                  style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    left: 0
                  }}
                  showLabels
                >
                  {surveyLocales.map(sl => (
                    <BottomNavigationAction
                      key={sl.id}
                      value={sl.locale.id}
                      label={sl.locale.jaLabel}
                      classes={{
                        root: classes.btnNavActionRoot
                      }}
                      className={classnames(
                        surveyLocales.length === 1 ? classes.soloLocale : "",
                        selectedSurveyLocale.localeId === sl.locale.id
                          ? classes.selectedNavItem
                          : ""
                      )}
                    />
                  ))}
                </BottomNavigation>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper
                className={classes.paperDiv}
                style={{height: 260, boxSizing: "inherit"}}
              >
                <h4 className={classes.paperTitle}>
                  アンケート進捗状況（全体）
                </h4>
                <br/>
                <span className={classes.paperDesc}>
                  人数（回答済み / 対象者数）
                </span>
                <span className={classes.paperStats}>
                  <CountUp start={0} end={survey.resultCount} duration={1.5}/>
                  {` / ${survey.employees}人`}
                </span>
                <div className={classes.progressDiv}>
                  <LinearProgress
                    className={classes.progress}
                    mode="determinate"
                    value={this.state.completed}
                    style={{color: "#678ecc"}}
                  />
                </div>
                <span className={classes.progressDesc}>回答率</span>
                <span className={classes.progressStats}>
                  {survey.progressRatio()}％
                </span>
                {survey.isMailSendToEmployee && (
                  <div style={{width: '100%'}}>
                    <button
                      className={classes.outputButton}
                      onClick={downloadSurveyAnswers}
                    >
                      アンケート実施URL/回答状況出力
                    </button>
                  </div>
                )}
              </Paper>
            </Grid>
          </Grid>

          <Paper>
            <div className={classes.paperHeader}>部門別回答済み人数</div>
            <div className={classes.paperContent}>
              <CTable>
                <CTableHead>
                  <CTableRow>
                    <CHeadCell>部門名</CHeadCell>
                    <CHeadCell width={200}>人数</CHeadCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {deptResults &&
                    deptResults.map(deptResult => (
                      <CTableRow key={deptResult.deptName}>
                        <CBodyCell>{deptResult.deptName}</CBodyCell>
                        <CBodyCell right>{deptResult.resultCount} 人</CBodyCell>
                      </CTableRow>
                    ))}
                </CTableBody>
              </CTable>
            </div>
          </Paper>
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(SurveyProgress);



// WEBPACK FOOTER //
// ./src/components/SurveyProgress.jsx